import React, { Component } from 'react';
import { connect } from 'react-redux';
import Picker from '../../base/Picker/Picker';

class PurchaseAddressPicker extends Component {

    render() {
        return(
            <Picker
                buttonId="purchaseAddressButton"
                buttonText={"Dodaj"}
                inputId="purchaseAddressInput"
                inputLabel={"Adres zakupu"}
                inputPlaceholder={"Adres zakupu..."}
                inputValue={this.props.customerCompanyName}
                onPickerButtonClick={this.props.onPickerButtonClick}/>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        customerCompanyName: state.customer.companyName
    };
};

const mapDispatchToProps = () => {
    return {
        
    };
};

PurchaseAddressPicker.propTypes = {
    
};

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseAddressPicker);


// WEBPACK FOOTER //
// ./src/components/ComplaintPositionComponents/PurchaseAddress/PurchaseAddressPicker.js